import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import R from 'ramda';

import Auth from '_components/auth_flow';

export default function AuthPage() {
  const dispatch = useDispatch();
  const { user } = useSelector(R.pick(['user']));

  useEffect(() => {
    if (!R.isEmpty(user)) {
      dispatch(push('/settings'));
    }
  }, []);

  return (
    <div className="survey-page page">
      <Auth />
    </div>
  );
}
